var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-idle',{attrs:{"loop":false,"reminders":_vm.reminders,"wait":_vm.wait,"duration":_vm.duration,"events":['click', 'mousemove', 'keypress']},on:{"idle":_vm.onidle,"remind":_vm.onremind}})}
var staticRenderFns = []

export { render, staticRenderFns }